import LanguageWrapper from './LanguageWrapper.container'

export default LanguageWrapper
